import React from 'react';
import { IBudgetItem } from '../../blueprint';
import TableRow from './table-row';
import css from '../../index.module.css';

interface CategorizedCostsTableProps {
  categorizedCosts: IBudgetItem;
}

export default function CategorizedCostsTable({
  categorizedCosts,
}: CategorizedCostsTableProps) {
  return (
    <>
      {categorizedCosts && Object.keys(categorizedCosts.children) ? (
        <div className={css['categorized-costs']}>
          <TableRow
            key={`row-${categorizedCosts.name}-${+new Date()}`}
            item={categorizedCosts}
          />

          {Object.keys(categorizedCosts.children).map((childName: any) => {
            const child = categorizedCosts.children[childName];
            return <TableRow key={`row-${child.name}`} item={child} />;
          })}
        </div>
      ) : null}
    </>
  );
}
